"use client"

import * as React from "react"
import * as SliderPrimitive from "@radix-ui/react-slider"
import { cn } from "@/utils/helpers/utils"

type SliderRowProps = {
   label: string
   value: number
   min: number
   max: number
   step: number
   rangeText?: string
   description?: string
   onChange: (value: number) => void
   className?: string
}

export function SliderRow({
   label,
   value,
   min,
   max,
   step,
   rangeText,
   description,
   onChange,
   className,
}: SliderRowProps) {
   return (
      <div className={cn("flex flex-col items-start gap-2 lg:flex-row lg:items-center lg:justify-between", className)}>
         <div className="space-y-1">
            <label className="text-sm font-bold">{label}</label>
            {description && <p className="text-xs text-muted-foreground">{description}</p>}
         </div>
         <div className="mt-2 flex flex-col items-end space-y-1">
            <SliderPrimitive.Root
               className="relative flex h-3 w-48 touch-none select-none items-center"
               value={[value]}
               min={min}
               max={max}
               step={step}
               onValueChange={(v) => onChange(v[0])}
            >
               <SliderPrimitive.Track className="relative h-1.5 w-full overflow-hidden rounded-full bg-gray-200">
                  <SliderPrimitive.Range className="absolute h-full bg-[#FBB040]" />
               </SliderPrimitive.Track>
               <SliderPrimitive.Thumb className="block h-4 w-4 rounded-full border border-gray-300 bg-white shadow transition-colors focus:outline-none focus:ring-1 focus:ring-[#FBB040] disabled:pointer-events-none disabled:opacity-50" />
            </SliderPrimitive.Root>
            <div className="flex w-full justify-between text-xs">
               <span className="font-semibold">
                  {value}
                  {max === 1 ? "" : "%"}
               </span>
               {rangeText && <p className="text-muted-foreground">{rangeText}</p>}
            </div>
         </div>
      </div>
   )
}
